<div>
  <div class="align-title">
    <div class="align-header-items">
      <h3
        fd-panel-title
        class="section-title"
        [title]="key + ''"
        style="font-weight: bold; font-size: 1.17em"
      >
        {{ to.label || key.toString() }}
      </h3>
      @if (to.required) {
        <span class="required-field">*</span>
      }
      @if (!!to.description) {
        <span>
          <app-help-popover
            [body]="arrayDescription"
            [headerTitle]="to.label || key.toString()"
            [placement]="'bottom'"
            [enabled]="!field.props.disabled"
          ></app-help-popover>
          <ng-template #arrayDescription>
            <fd-text [text]="to.description"></fd-text>
          </ng-template>
        </span>
      }
      <button
        fd-button
        class="add-label-button"
        type="button"
        fdType="emphasized"
        [disabled]="field.props.disabled"
        (click)="add(null)"
        [fdCompact]="true"
        [title]="getAddTooltip()"
      >
        <app-icon icon="plus" size="lg"></app-icon>
      </button>
    </div>
  </div>
  @if (showError && formControl.errors) {
    <fd-message-strip class="error-strip" type="error" [dismissible]="false">
      <formly-validation-message [field]="field"></formly-validation-message>
    </fd-message-strip>
  }

  @for (theField of field.fieldGroup; track theField; let i = $index) {
    <div [ngStyle]="{ 'padding-bottom': '0.1rem' }">
      <fd-layout-grid [noGap]="true" style="padding-left: 0">
        <div fdLayoutGridCol="11" style="padding-left: 0">
          <formly-field
            [field]="theField"
            [ngStyle]="{ width: '100%' }"
          ></formly-field>
        </div>
        <div fdLayoutGridCol="1" class="remove-btn">
          @if (field.templateOptions["removable"] !== false) {
            <div>
              &nbsp;&nbsp;<button
                fd-button
                class="custom-icon"
                (click)="remove(i)"
                fdType="transparent"
                [fdCompact]="true"
                [disabled]="field.props.disabled"
              >
                <app-icon icon="trash" size="lg"></app-icon>
              </button>
            </div>
          }
        </div>
      </fd-layout-grid>
      <!--<hr *ngIf="field.fieldGroup[0].fieldGroup" style="width:90%;text-align:left;margin-left:0">-->
    </div>
  }
</div>
